import { Form, Input } from "antd";
import React, { ChangeEvent } from "react";
import "./FromItemInput.scss";

interface FormItemInputProps {
  name: string;
  placeholder?: string;
  label: string;
  rules:
    | { required: boolean; message?: string }
    | [{ required: boolean; message?: string }, { pattern: RegExp; message: string }];
  defaultValue?: string;
  disabled?: boolean;
  isSettingInput?: boolean;
  prefix?: string;
  onChangeFunction?: (e: ChangeEvent<HTMLInputElement>) => void;
  maxLength?: number;
}

const FormItemInput: React.FC<FormItemInputProps> = ({
  name,
  placeholder,
  rules,
  label,
  defaultValue,
  disabled,
  isSettingInput,
  prefix,
  onChangeFunction,
  maxLength,
}) => {
  return (
    <Form.Item
      className={`form-item__input ${isSettingInput ? "setting" : ""}`}
      name={name}
      label={label}
      rules={Array.isArray(rules) ? rules : [{ required: rules.required, message: rules.message }]}
    >
      <Input
        className={"input"}
        prefix={prefix ? <img src={prefix} alt={"prefix"} /> : null}
        onChange={onChangeFunction}
        placeholder={placeholder}
        defaultValue={defaultValue}
        disabled={disabled}
        maxLength={maxLength}
      />
    </Form.Item>
  );
};

export default FormItemInput;
